import React, { useEffect, useState } from 'react';

import clsx from 'clsx';
import Paper from '@gogame/ui/Paper';
import Typography from '@gogame/ui/Typography';
import { blend, makeStyles } from '@gogame/ui/styles';

import { useKeyboardControl } from './useKeyboardControl';

const useStyles = makeStyles((theme) => ({
  items: {
    padding: '8px 0',
    position: 'relative',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  item: {
    display: 'block',
    cursor: 'pointer',
    margin: '0',
    width: '100%',
    textAlign: 'left',
    background: 'transparent',
    border: '1px solid transparent',
    padding: '0 16px',
    height: '48px',
  },
  isSelected: {
    backgroundColor: blend(
      theme.palette.background.paper,
      theme.palette.action.active,
      theme.palette.action.activatedOpacity
    ),
  },
  name: {
    color: theme.palette.text.primary,
  },
  email: {
    color: theme.palette.text.secondary,
  },
}));

export default React.forwardRef(({ items, command }, ref) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const chooseItem = (index) => {
    const item = items[index];

    if (item) {
      command({ id: item.id, label: item.name });
    }
  };

  useKeyboardControl(
    {
      selectedIndex,
      setSelectedIndex,
      items,
      chooseItem,
    },
    ref
  );
  const classes = useStyles();

  useEffect(() => setSelectedIndex(0), [items]);

  const handleMouseEnter = (index) => {
    setSelectedIndex(index);
  };

  if (!items.length) {
    return null;
  }
  return (
    <Paper className={classes.items} elevation={16}>
      {items.map((item, index) => (
        <button
          className={clsx(classes.item, {
            [classes.isSelected]: index === selectedIndex,
          })}
          key={index}
          onMouseEnter={() => handleMouseEnter(index)}
          onClick={() => chooseItem(index)}
        >
          <Typography variant={'body1'} className={classes.name}>
            {item.name}
          </Typography>
          <Typography variant={'caption'} className={classes.email}>
            {item.email}
          </Typography>
        </button>
      ))}
    </Paper>
  );
});
